import { Mapper } from './mapper';

export const ContratoRegimeParcial = Mapper.from([
  [0, 'Não é contrato em tempo parcial'],
  [1, 'Limitado a 25 horas semanais'],
  [2, 'Limitado a 30 horas semanais'],
  [3, 'Limitado a 26 horas semanais'],
]);
